var _style, _polyline, _line, _line2, _path, _line3, _path2, _path3, _path4, _g, _polyline2, _line4, _polyline3, _line5, _path5, _line6, _polyline4, _line7, _line8, _polyline5, _line9, _line10, _line11, _g2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle, _path13, _path14, _path15, _path16, _path17, _circle2, _polyline6, _polyline7, _polyline8, _polyline9, _circle3, _circle4, _path18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccessDenied(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 451 237",
    style: {
      enableBackground: "new 0 0 451 237"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#666666;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#666666;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#666666;stroke-width:1.8953;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:#F8D6E3;}\n\t.st4{fill:#4D4D4D;}\n\t.st5{font-family:'Montserrat-Medium';}\n\t.st6{font-size:14.4122px;}\n\t.st7{fill:none;stroke:#666666;stroke-width:1.5224;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st8{fill:#FFFFFF;stroke:#666666;stroke-width:1.5224;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st9{fill:#FFFFFF;stroke:#666666;stroke-width:1.0925;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st10{fill:#FFFFFF;stroke:#666666;stroke-width:1.0739;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st11{fill:none;stroke:#666666;stroke-width:1.0925;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "0.09,230.53 73.05,230.53 73.05,219.2 80.14,212.12 "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 79.43,
    y1: 231.24,
    x2: 450.59,
    y2: 231.24
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 213.64,
    y1: 25.41,
    x2: 220.72,
    y2: 25.41
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M228.51,26.82h7.79c0,0,3.54-13.46,17.71-7.08c0,0,10.63-15.58,23.38-7.79c0,0,9.21,5.67,8.5,16.29"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 338.37,
    y1: 77.52,
    x2: 346.16,
    y2: 77.52
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M349.71,76.82h9.92c0,0,3.78-12.75,15.11-6.14c0,0,6.14-17.94,27.86-14.17c0,0,11.33,6.14,13.69,18.89 c0,0,6.61-4.25,7.56,2.36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.49,140.19c4.61,0.43,8.27,5.33,7.37,9.87c1.71-4.59,6.67-7.76,11.56-7.37"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.17,125.69c4.43,1.14,8.92,2.31,12.88,4.6c3.96,2.29,7.38,5.89,8.42,10.34c-0.93-3.05,0.77-6.43,3.31-8.36 c2.55-1.92,5.78-2.67,8.92-3.2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 117.91,
    y1: 107.75,
    x2: 117.91,
    y2: 230.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 125.47,
    y1: 107.75,
    x2: 125.47,
    y2: 230.06
  }))), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "374.8,145.53 376.22,175.28 374.8,231 "
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 388.97,
    y1: 202.67,
    x2: 404.55,
    y2: 204.09
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "349.77,187.56 375.75,214.95 399.36,192.28 "
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 351.19,
    y1: 203.62,
    x2: 358.27,
    y2: 196.53
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M395.58,176.23c1.42-0.47,17.94,2.36,17.94,2.36"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 340.8,
    y1: 179.06,
    x2: 359.22,
    y2: 179.06
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "348.83,167.73 376.69,195.12 411.64,162.06 "
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 364.41,
    y1: 154.5,
    x2: 362.52,
    y2: 163.48
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 388.5,
    y1: 149.78,
    x2: 389.44,
    y2: 163.95
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "397.94,156.87 376.22,175.28 350.25,152.62 "
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 54.64,
    y1: 195.59,
    x2: 54.64,
    y2: 229.12
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 64.08,
    y1: 203.62,
    x2: 54.87,
    y2: 212.82
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 53.69,
    y1: 219.67,
    x2: 44.25,
    y2: 210.7
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "150.9,2.59 92.49,2.59 63.28,53.17 92.49,103.75 150.9,103.75 180.1,53.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "148.78,6.25 94.6,6.25 67.51,53.17 94.6,100.09 148.78,100.09 175.87,53.17  "
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 96.7117 45.5522)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st4 st5 st6"
  }, "Access"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.4,
    y: 15.29,
    className: "st4 st5 st6"
  }, "Denied!")))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M248.29,173.51c0,0-13.12,42.55-9.6,56.15c0,0-2.37,1.18-10.05-0.02"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M263.67,177.19c0,0,7.01,25.52,8.8,34.9c1.19,6.24-1.25,17.74-1.25,17.74s9.66-0.99,11.23,0.02"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M258,136.64"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M268.51,154.02l0.56,0.94c0.72,1.22,2.47,1.26,3.25,0.07l7.37-11.18c0,0,6.16,0.97,9.5-4.72"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M241.43,154.03l-0.56,0.94c-0.73,1.21-2.47,1.25-3.25,0.07l-7.35-11.19c0,0-6.17,0.95-9.49-4.74"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M255.66,185.7l13.31-0.09c3.22-0.58,3.89-1.28,4.82-2.26c4.27-4.47-11.09-51.19-11.09-51.19l-14.8,0.1 c0,0-14.72,46.92-10.39,51.33c0.94,0.96,1.62,1.66,4.85,2.19L255.66,185.7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M261.61,132.61"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 254.43,
    cy: 121.6,
    r: 16.91
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M248.38,128.84c0,0,5.91,7.52,12.35,0H248.38z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M268.51,154.02l0.56,0.94c0.72,1.22,2.47,1.26,3.25,0.07l7.37-11.18c0,0,6.16,0.97,9.5-4.72"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M241.43,154.03l-0.56,0.94c-0.73,1.21-2.47,1.25-3.25,0.07l-7.35-11.19c0,0-6.17,0.95-9.49-4.74"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M255.66,185.7l13.31-0.09c3.22-0.58,3.89-1.28,4.82-2.26c4.27-4.47-11.09-51.19-11.09-51.19l-14.8,0.1 c0,0-14.72,46.92-10.39,51.33c0.94,0.96,1.62,1.66,4.85,2.19L255.66,185.7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M261.61,132.61"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 254.43,
    cy: 121.6,
    r: 16.91
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "254.55,146.03 259.12,162.65 254.55,169.12 "
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "254.55,147.32 251.06,163.01 254.55,169.12 "
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    className: "st11",
    points: "255.36,141.75 259.65,161.06 255.36,168.58 "
  })), _polyline9 || (_polyline9 = /*#__PURE__*/React.createElement("polyline", {
    className: "st11",
    points: "255.07,141.71 251.19,161.11 255.64,168.53 "
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 255.36,
    cy: 141.73,
    r: 1.61
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 255.36,
    cy: 141.19,
    r: 2.15
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M248.38,128.84c0,0,5.91,7.52,12.35,0H248.38z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessDenied);
export default __webpack_public_path__ + "static/media/access_denied.0b48aa73d9b001121aa1c456874e836e.svg";
export { ForwardRef as ReactComponent };